const INITIAL_STATE = {
    itens: [],
    loading: false,
    error: null
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type){
        case 'BUSCA_TODOS_SERVICOS':
            return {...state, loading: true};    
            
        case 'BUSCA_TODOS_SERVICOS_SUCESSO':
            return {...state, loading: false, itens: action.payload};    
    
        case 'BUSCA_TODOS_SERVICOS_ERRO':
            return {...state, loading: false, itens: [], error: action.payload};  

        default:
            return state;
    }
}